// Rules read off a combination's raw system type label ("Heat Pump +
// Evaporator Coil + Natural Gas Furnace", "Packaged Gas + LP Conversion
// Kit"). The same rules the API applies (ducted-oversize), kept in one place
// so the GUI never disagrees with the server about what a label means.

// A packaged (self-contained) system is one unit: the coil and blower are
// built into what the combination row carries as the outdoor model, so the
// label names no indoor or blower part — anything after a "+" is an
// accessory (heat kit, LP conversion kit), not a component to source or
// keep. Every packaged label leads with the word, the terminal units
// ("Packaged Terminal") included.
const PACKAGED_LABEL = /^Packaged\b/i;

export function isPackagedSystemTypeLabel(systemTypeLabel: string): boolean {
  return PACKAGED_LABEL.test(systemTypeLabel.trim());
}

// A heat pump's cooling side is held to the heat-pump sizing band, everything
// else to the AC band. A packaged dual fuel unit is a heat pump with a
// furnace built in, though its label never says "Heat Pump".
export function isHeatPumpSystemTypeLabel(systemTypeLabel: string): boolean {
  return (
    systemTypeLabel.includes('Heat Pump') ||
    systemTypeLabel.startsWith('Packaged Dual Fuel')
  );
}
